import Route from 'cio/routes/base';
import Transition from '@ember/routing/-private/transition';
import { redirectIfNoPermission } from 'cio/utils/route-access';

export default class ExportsRoute extends Route {
  crumb() {
    return {
      name: 'Exports',
      path: this.routeName,
    };
  }

  async beforeModel(transition: Transition) {
    await super.beforeModel(transition);

    return redirectIfNoPermission(this, 'journeys/exports/view', transition);
  }
}
